var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "894 424 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M909 429.625a3.124 3.124 0 1 0-6.25 0c0 1.422.95 2.621 2.246 3-.023.629-.164 1.113-.43 1.441-.601.75-1.925.875-3.328 1.004-1.101.102-2.242.211-3.176.66v-5.625a3.123 3.123 0 0 0-.937-6.105 3.124 3.124 0 0 0-.938 6.105v7.786a3.132 3.132 0 0 0-2.187 2.984 3.124 3.124 0 1 0 6.25 0 3.12 3.12 0 0 0-2-2.914c.121-.203.305-.383.582-.523.633-.32 1.578-.407 2.582-.5 1.649-.153 3.516-.329 4.617-1.696.547-.68.824-1.554.844-2.652a3.138 3.138 0 0 0 2.125-2.965Zm-11.875-3.125c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625Zm0 15a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625a.627.627 0 0 1-.625.625Zm8.75-12.5c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-code-branch"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchesIcon);
export default __webpack_public_path__ + "static/media/BranchesIcon.56299e5eb8b46388cbad84c37a99ac4e.svg";
export { ForwardRef as ReactComponent };